import React, { ChangeEvent, FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../providers/AuthProvider';
import useRest, { HTTPMethod } from '../../hooks/useRest';
import Input, { InputType } from '../Input';
import { SegmentCard } from '@uninow/web-ui-lib/components/molecules';
import { SecondaryButton, ButtonType } from '@uninow/web-ui-lib/components/atoms';

const ChangePasswordForm: React.FC = () => {
  const { t } = useTranslation();
  // @ts-ignore
  const { getTokenSilently } = useAuth();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
  const { handleSubmit, loading, validationMessages } = useRest({
    // @ts-ignore
    path: `${window.REACT_APP_ACCOUNTS_API_URL}/api/v1/password-change`,
    method: HTTPMethod.POST,
    headers: {
      Authorization: `Bearer ${getTokenSilently()}`,
    },
    data: {
      oldPassword,
      newPassword,
      newPasswordConfirmation,
    },
    onSuccess: () => {
      console.log('Success');
    },
  });
  return (
    <div className="mt-6 sm:mt-5">
      <form
        onSubmit={(e: FormEvent) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <SegmentCard title={t('forms.passwordUpdate.heading')} description={t('forms.passwordUpdate.info')}>
          <Input
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setOldPassword(e.target.value);
            }}
            type={InputType.password}
            label={t('inputs.oldPassword')}
            id="oldPassword"
            required={true}
            value={oldPassword}
            validationMessages={validationMessages}
          />
          <Input
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setNewPassword(e.target.value);
            }}
            type={InputType.password}
            label={t('inputs.newPassword')}
            id="newPassword"
            required={true}
            value={newPassword}
            validationMessages={validationMessages}
          />
          <Input
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setNewPasswordConfirmation(e.target.value);
            }}
            type={InputType.password}
            label={t('inputs.newPasswordConfirmation')}
            id="newPasswordConfirmation"
            required={true}
            value={newPasswordConfirmation}
            validationMessages={validationMessages}
          />
          <div className="pt-6 flex flex-row justify-end">
            <SecondaryButton type={ButtonType.submit} label={t('actions.save')} loading={loading} />
          </div>
        </SegmentCard>
      </form>
    </div>
  );
};

export default ChangePasswordForm;
